"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var AutoHeightTextArea = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AutoHeightTextArea, _Component);

  function AutoHeightTextArea() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AutoHeightTextArea);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutoHeightTextArea)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "reHeight", function () {
      _this._textarea.style.height = '1px';
      _this._textarea.style.height = "".concat(_this._textarea.scrollHeight, "px");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRef", function (el) {
      if (!el) {
        return;
      }

      _this._textarea = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "change", function () {
      var onChange = _this.props.onChange;

      _this.reHeight();

      if (onChange) {
        onChange.apply(void 0, arguments);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(AutoHeightTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._textarea.style.position = 'absolute';
      this._textarea.style.visibility = 'hidden';
      this.reHeight();
      this._textarea.style.position = '';
      this._textarea.style.visibility = '';
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var value = _ref.value;
      var props = this.props;

      if (value !== props.value) {
        this.reHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.disabled;
      return _react.default.createElement("textarea", (0, _extends2.default)({}, this.props, {
        ref: this.setRef,
        rows: "1",
        onChange: this.change,
        style: {
          resize: 'none !important',
          wordWrap: 'break-word',
          width: '240px'
        },
        readOnly: disabled
      }));
    }
  }]);
  return AutoHeightTextArea;
}(_react.Component);

exports.default = AutoHeightTextArea;